import Marquee from "react-fast-marquee";

const ITEMS = [
  "20 YEARS OF CRAFT",
  "WEB DEVELOPMENT",
  "MOBILE APPS",
  "UX DESIGN",
  "VIDEO EDITING",
  "CLOUD ENGINEERING",
  "AI PRODUCTS",
  "SINCE 2005",
];

export const MarqueeStrip = () => {
  return (
    <section className="relative border-y border-white/[0.06] bg-[#050A08] py-8 md:py-10">
      <div className="marquee-fade">
        <Marquee
          gradient={false}
          speed={30}
          pauseOnHover={false}
          autoFill
        >
          {ITEMS.map((it, i) => (
            <span
              key={i}
              className="mx-8 md:mx-14 inline-flex items-center gap-8 md:gap-14 font-display uppercase tracking-tight text-[9vw] md:text-[7vw] leading-none"
            >
              <span
                className={
                  i % 2 === 0
                    ? "text-white/[0.85]"
                    : "text-transparent [-webkit-text-stroke:1px_rgba(0,208,132,0.5)]"
                }
              >
                {it}
              </span>
              <span className="inline-block w-3 h-3 rounded-full bg-emerald-400/70 shrink-0" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
